import React, { useState } from 'react';
import {
	DwListItem,
	DwListItemWrapper,
} from '../../../../../../ConversationGroup.styled';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { removeDwUser } from '@/API/repositories/tickets';
import Icon from '@/common/components/Icon';

const DwItem = ({ user, loadData, selectedTicket }) => {
	const [dwRemoving, setDwRemoving] = useState();

	const { makeRequest } = useRequestsContext();

	const handleRemoveDw = async (userToRemove) => {
		setDwRemoving((prev) => [...(prev || []), userToRemove]);

		const response = await makeRequest(
			removeDwUser.bind(null, selectedTicket._id, userToRemove.value),
		);

		if (response.data) {
			await loadData();
		}

		setDwRemoving((prev) =>
			prev?.filter((user) => user.value !== userToRemove.value),
		);
	};

	return (
		<DwListItemWrapper>
			{user.label}
			<DwListItem
				onClick={() => handleRemoveDw(user)}
				className='animation-scale'
			>
				<Icon
					name={
						dwRemoving?.find(
							(removingUser) => removingUser.value === user.value,
						)
							? 'spinner'
							: 'x'
					}
				/>
			</DwListItem>
		</DwListItemWrapper>
	);
};

export default DwItem;
